import * as angular from 'angular';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { downgradeInjectable } from "@angular/upgrade/static";

@Injectable({ providedIn: 'root' })
export class PushNotificationsService {
    public permission: Permission;
	private path!: string;
    

    constructor(@Inject(HttpClient) private httpClient: HttpClient) {
        this.permission = this.isSupported() ? 'default' : 'denied';
	    this.path = (window as any).baseApiPath;
    }

    public isSupported(): boolean {
        return 'Notification' in window;
    }

    requestPermission(): void {
        let self = this;
        if ('Notification' in window) {
            Notification.requestPermission(function(status) {
                return self.permission = status;
            });
        }
    }

    create(title: string, options ? : PushNotification): any {
        let self = this;
        return new Observable(function(obs: any) {
            if (!('Notification' in window)) {
                console.log('Notifications are not available in this environment');
                obs.complete();
            }
//            if (self.permission !== 'granted') {
//                console.log("The user hasn't granted you permission to send push notifications");
//                obs.complete();
//            }
            let _notify = new Notification(title, options);
            _notify.onshow = function(e) {
                return obs.next({
                    notification: _notify,
                    event: e
                });
            };
            _notify.onclick = function(e) {
                return obs.next({
                    notification: _notify,
                    event: e
                });
            };
            _notify.onerror = function(e) {
                return obs.error({
                    notification: _notify,
                    event: e
                });
            };
            _notify.onclose = function() {
				console.log('close notification has been triggered for: ', this.data);
				if (this.data) {
					let url = self.path + 'webAccesNotifications/' + this.data.join(',');
					self.httpClient.delete(url).pipe(
						timeout(3000)
					).subscribe(
		            	() => {
							console.log('notifications for these ids: ', this.data, ' have been deleted');
						}
	            	);
				}
				return obs.complete();
            };
        });
    }

    generateNotification(source: Array < any > ): void {
        let self = this;
        source.forEach((item) => {
            let options = {
                body: item.alertContent,
                icon: "../../../assets/images/logo.png",
                tag: item.tag,
                data: item.data
            };
            let notify = self.create(item.title, options).subscribe();
        })
    }
}

angular
	.module('auroraApp')
	.service('pushNotificationsService', downgradeInjectable(PushNotificationsService));

export declare type Permission = 'denied' | 'granted' | 'default';

export interface PushNotification {
    body ? : string;
    icon ? : string;
    tag ? : string;
    data ? : any;
    renotify ? : boolean;
    silent ? : boolean;
    sound ? : string;
    noscreen ? : boolean;
    sticky ? : boolean;
    dir ? : 'auto' | 'ltr' | 'rtl';
    lang ? : string;
    vibrate ? : number[];
}